import styled from "styled-components"

const Summary = styled.summary`
  padding: 10px;
  cursor: pointer;
  font-size: 24px;
  outline: 0;
`

export default Summary
